/**
 * This client was automatically generated by Segment Typewriter. ** Do Not Edit **
 */

import * as Segment from './segment'

export interface AccountCreated {
	/**
	 * Whether the element pressed was a button or a link.
	 */
	button_or_link: string
	/**
	 * The location of the button or link on the page or screen.
	 */
	button_or_link_location?: string
	/**
	 * The text on the button or link.
	 */
	button_or_link_text?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Split experiments and treatment that the user is assigned to
	 */
	experiments?: Record<string, any>
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * The platform on which the user signed up. For example, mobile or web.
	 */
	platform_type?: string | null
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
	/**
	 * ID to track events triggered during a single session
	 */
	session_id?: string
	user_id?: number
}
export interface AgreedToTosPrivacy {
	/**
	 * The location of the checkbox on the page or screen.
	 */
	checkbox_location?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * The feature for which the TOS/Privacy was agreed to
	 */
	feature?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
	/**
	 * Supplementary tracking identifier for the specific instance where the TOS/Privacy have been agreed to
	 */
	track_id?: string
}
export interface BackButtonPressed {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * The current Design Studio mode
	 */
	design_studio_mode?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * The Partner if button is embedded with in a Partner specific page context
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface ButtonImpression {
	/**
	 * Id of display image in Homeowner App
	 */
	ai_display_image_id?: number
	/**
	 * Id of generated image in Homeowner App
	 */
	ai_generated_image_id?: number
	/**
	 * Id of original image uploaded by user in Homeowner App
	 */
	ai_original_image_id?: number
	/**
	 * Database object name associated with this event
	 */
	backend_id_type?: string
	/**
	 * Database object id associated with this event
	 */
	backend_id_value?: string
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	button_type?: string
	/**
	 * A boolean indicating whether the user is using dense for the current capture
	 */
	dense_guidance_capture?: boolean
	/**
	 * A boolean indicating whether dense is enabled for the camera.
	 */
	dense_guidance_enabled_for_camera?: boolean
	/**
	 * A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
	 */
	dense_guidance_mode?: string
	/**
	 * The Design Studio mode the user is currently in
	 */
	design_studio_mode?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The domain object being operated on
	 */
	item_type?: string
	/**
	 * The client identifier of the Job the user is capturing.
	 */
	job_client_identifier?: string
	/**
	 * The Hyperion Job Id.
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta?: boolean
	provider_name?: string
	/**
	 * Space type of uploaded image in Homeowner App
	 */
	space_type?: string | null
	/**
	 * Style of generated image in Homeowner App
	 */
	style?: string
	/**
	 * Total number of edit material classes in Gen AI
	 */
	total_material_classes?: number
	/**
	 * Static track id for button
	 */
	track_id?: string
	/**
	 * View type in Homeowner App (e.g. grid-view, full-screen-view)
	 */
	view_type?: string
}
export interface ButtonPressed {
	/**
	 * ID of the relevant AIDisplayImage
	 */
	ai_display_image_id?: number
	/**
	 * ID of the relevant AIGeneratedImage
	 */
	ai_generated_image_id?: number
	/**
	 * Whether an image was watermarked
	 */
	ai_image_watermarked?: boolean
	/**
	 * ID of the relevant AiOriginalImage
	 */
	ai_original_image_id?: number
	/**
	 * Database object name associated with this event
	 */
	backend_id_type?: string
	/**
	 * Database object id associated with this event
	 */
	backend_id_value?: string
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	button_type?: string
	/**
	 * The color group from a color selected that was not defined in texture details, "Popular", "Statement", "Reds", etc...
	 */
	color_group?: string
	/**
	 * The hexadecimal representation of the color selected. For example, "#ffffff", "#ebdec4", "#ddb582", etc...
	 */
	color_hex?: string
	/**
	 * The name of the color selected. For example generic names "Reds" and "Greens", or branded names "Rustic Barn", "Wintery White", etc...
	 */
	color_name?: string
	/**
	 * A boolean indicating whether the user is using dense for the current capture
	 */
	dense_guidance_capture?: boolean
	/**
	 * A boolean indicating whether dense is enabled for the camera.
	 */
	dense_guidance_enabled_for_camera?: boolean
	/**
	 * A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
	 */
	dense_guidance_mode?: string
	/**
	 * Type of device being viewed
	 */
	device_type?: string
	/**
	 * The region being edited
	 */
	edit_region?: string
	/**
	 * The type of edit (paint, walls, roof, etc)
	 */
	edit_type?: string
	/**
	 * The generated image id of the edited image.
	 */
	edited_image_id?: number
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The number of images that are saved to projects
	 */
	images_saved?: number
	/**
	 * The domain object being operated on
	 */
	item_type?: string
	/**
	 * The client identifier of the Job the user is capturing.
	 */
	job_client_identifier?: string
	/**
	 * the name of a job deliverable, such as "capture only", "complete", etc
	 */
	job_deliverable?: string
	/**
	 * The Hyperion Job Id.
	 */
	job_id?: number | null
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Manufacturer of product
	 */
	manufacturer?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * Insurance or pro
	 */
	org_type?: string
	/**
	 * unique id of the relevant piece of content for this button (e.g. an image_id for a download button for that image)
	 */
	output_id?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name?: string
	/**
	 * The Partner if button is embedded with in a Partner specific page context
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * mobile or web
	 */
	platform_type?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta?: boolean
	/**
	 * Name of the product selected
	 */
	product_group?: string
	/**
	 * Name of the product selected
	 */
	product_name?: string
	/**
	 * ID of the project
	 */
	project_id?: number
	/**
	 * Name of the Gen AI project
	 */
	project_name?: string
	/**
	 * The manufacturer of the product/material
	 */
	provider_name?: string
	/**
	 * details on actions for save_as_template feature in EHI
	 */
	save_as_template_details?: Record<string, any>
	/**
	 * ID to track events triggered during a single session
	 */
	session_id?: string
	/**
	 * Space type of uploaded image in Homeowner App
	 */
	space_type?: string
	/**
	 * Style of image or design
	 */
	style?: string
	/**
	 * Total number of edit material classes in Gen AI
	 */
	total_material_classes?: number
	/**
	 * Static track id for button
	 */
	track_id?: string
	/**
	 * trade type from ehi codebase
	 */
	trade?: string
	/**
	 * Indicates if the event was triggered for an anonymous user or a logged in user.
	 */
	user_authenticated?: boolean
	/**
	 * user's email
	 */
	user_email?: string
	/**
	 * Hyperion user ID
	 */
	user_id?: number
	/**
	 * View type in Homeowner App (e.g. grid-view, full-screen-view)
	 */
	view_type?: string
}
export interface CaptureStarted {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The client identifier of the Job the user is capturing.
	 */
	job_client_identifier: string
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.

	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface CaptureSubmitted {
	/**
	 * The location of the button on the page or screen.

	 */
	button_location?: string
	/**
	 * The text on the button.

	 */
	button_text: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The client identifier of the Job the user is capturing.
	 */
	job_client_identifier: string
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.

	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
	/**
	 * Progressive Uploads was enabled for the capture.
	 */
	progressive_upload?: boolean
}
export interface CheckboxSelected {
	/**
	 * Database object name associated with this event
	 */
	backend_id_type?: string
	/**
	 * Database object value associated with this event
	 */
	backend_id_value?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The Hyperion Job Id
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * The description of the set of options
	 */
	options: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * Where does this checkbox appear
	 */
	page_or_screen_name?: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Is this field the primary CTA
	 */
	primary_cta?: boolean
	/**
	 * The thing being selected
	 */
	selection: string
	/**
	 * user's email
	 */
	user_email?: string
	/**
	 * Id of the user
	 */
	user_id?: number
}
export interface CheckboxToggled {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * Value of checkbox
	 */
	checked: boolean
	/**
	 * A boolean indicating whether the user is using dense for the current capture
	 */
	dense_guidance_capture?: boolean
	/**
	 * A boolean indicating whether dense is enabled for the camera.
	 */
	dense_guidance_enabled_for_camera?: boolean
	/**
	 * A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
	 */
	dense_guidance_mode?: string
	/**
	 * The Design Studio mode the user is currently in
	 */
	design_studio_mode?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The client identifier of the Job the user is capturing.
	 */
	job_client_identifier?: string
	/**
	 * The Hyperion Job Id.
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * The Partner if button is embedded with in a Partner specific page context
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
	/**
	 * template id from ehi code base
	 */
	template_id?: number
	/**
	 * template name from ehi code base
	 */
	template_name?: string
	/**
	 * Static track id for button
	 */
	track_id?: string
	/**
	 * trade type enum from ehi code base
	 */
	trade_type?: string
	user_email?: string
	user_id?: number
}
export interface DataSaved {
	/**
	 * The backend id type of the item represented by the saved data.
	 */
	backend_id_type?: string
	/**
	 * The backend id value of the item represented by the saved data.
	 */
	backend_id_value?: string
	/**
	 * The feature that the saved data is associated with.
	 */
	feature?: string
	/**
	 * the label of input used to save data (see inputPressed event for parallel field)
	 */
	input_label?: string
	/**
	 * The item/object type that the saved data is associated with.
	 */
	item_type?: string
	/**
	 * The page or screen where the save occurred.
	 */
	page_or_screen_name?: string
	/**
	 * The parent item/object id that the saved data is associated with. This could be a `job`, `estimate`, `sales_opportunity`, etc.
	 */
	parent_id?: number
	/**
	 * The data payload of the saved data.
	 */
	saved_data?: Record<string, any>
}
export interface DenseCaptureStarted {
	/**
	 * A boolean indicating whether the user is using dense for the current capture
	 */
	dense_guidance_capture: boolean
	/**
	 * A boolean indicating whether dense is enabled for the camera.
	 */
	dense_guidance_enabled_for_camera: boolean
	/**
	 * A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
	 */
	dense_guidance_mode: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The client identifier of the Job the user is capturing.
	 */
	job_client_identifier?: string
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.

	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
}
export interface ElementDragged {
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	name: string
	new_position: number
	old_position: number
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	page_or_screen_name?: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	user_email?: string
	user_id?: number
}
export interface ElementViewed {
	/**
	 * The Design Studio mode the user is currently in
	 */
	design_studio_mode?: string
	/**
	 * Name of the element that was viewed
	 */
	element_name?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * The Hyperion Job Id.
	 */
	job_id?: number
	/**
	 * The total number of successful Xactimate Guided Estimates submissions for the user
	 */
	lifetime_xactimate_successful_submission?: number
	/**
	 * Name of page
	 */
	page_or_screen_name?: string
	/**
	 * Partner specific page
	 */
	partner_id?: number
	/**
	 * Key for the tracked event
	 */
	track_id?: string
	user_email?: string
	user_id?: number
}
export interface Error {
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * the error message displayed to users
	 */
	message?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * HTTP status code e.g. 401
	 */
	status?: number
	/**
	 * what kind of error
	 */
	type: string
}
export interface FeatureUpvoted {
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * The name of the feature the user upvoted.
	 */
	feature: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The Hyperion Job Id.
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the feature was upvoted.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
}
export interface HomeownerIdentified {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button or link, likely replaced button_text.
	 */
	button_or_link_text?: string | null
	/**
	 * The text on the button.
	 */
	button_text?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Split experiments and treatment that the user is assigned to
	 */
	experiments?: Record<string, any>
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface ImageClicked {
	/**
	 * ID of the relevant AiGeneratedImage
	 */
	ai_generated_image_id?: number
	/**
	 * ID of the relevant AiOriginalImage
	 */
	ai_original_image_id?: number
	/**
	 * Device type the image was clicked on
	 */
	device_type?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * The Hyperion org_id
	 */
	org_id?: number
	/**
	 * Supplemental tracking id to track which image was clicked
	 */
	output_id?: string
	/**
	 * The name of the page or screen where the image was clicked.
	 */
	page_or_screen_name?: string
	/**
	 * ID to track events triggered by anonymous users
	 */
	session_id?: string
	/**
	 * Space type of the image clicked
	 */
	space_type?: string
	/**
	 * Style of the image clicked
	 */
	style?: string
	/**
	 * Unique id to track this event
	 */
	track_id?: string
	/**
	 * Indicates if the event was triggered from an anonymous user or not
	 */
	user_authenticated?: boolean
	/**
	 * The Hyperion user_id
	 */
	user_id?: number
}
export interface ImageLoaded {
	/**
	 * ID of the relevant AiGeneratedImage
	 */
	ai_generated_image_id?: number
	/**
	 * Whether an AI generated image was watermarked
	 */
	ai_image_watermarked?: boolean
	/**
	 * Original image ID
	 */
	ai_original_image_id?: number
	/**
	 * type of device being viewed
	 */
	device_type?: string
	/**
	 * Tracking the feature where the image was loaded
	 */
	feature?: string
	/**
	 * Identifies the method used to generate the image
	 */
	image_generation_type?: string
	/**
	 * Identifies whether this image load event is a generation request
	 */
	is_generation_request?: boolean
	/**
	 * Optional tracking field to track total latency (in milliseconds) as an alternative to tracking the request and response timestamps
	 */
	loading_time_ms?: number
	/**
	 * Hyperion org ID
	 */
	org_id?: number
	/**
	 * Unique id for each image
	 */
	output_id?: string
	/**
	 * Page or screen name where the image was loaded
	 */
	page_or_screen_name?: string
	/**
	 * Hyperion partner ID
	 */
	partner_id?: number
	/**
	 * the time (in milliseconds) when the image was requested
	 */
	request_timestamp_ms?: number
	/**
	 * the time (in milliseconds) when the image response was loaded
	 */
	response_timestamp_ms?: number
	/**
	 * Path for the sample image loaded (used as unique identifier)
	 */
	sample_image_path?: string
	/**
	 * the time (in milliseconds) for image generation on server
	 */
	server_loading_time_ms?: number
	/**
	 * ID to track events triggered by anonymous users
	 */
	session_id?: string
	/**
	 * Space type of the image that was loaded
	 */
	space_type?: string
	/**
	 * Image style
	 */
	style?: string
	/**
	 * Supplemental tracking identifier for the situation where an image is being loaded
	 */
	track_id?: string
	/**
	 * Indicates if the event was triggered from an anonymous user or not
	 */
	user_authenticated?: boolean
	/**
	 * Hyperion user ID
	 */
	user_id?: number
	/**
	 * Indicates if user has went offline during loading of image
	 */
	went_offline?: boolean
}
export interface ImageUploaded {
	/**
	 * ID of the relevant AiGeneratedImage
	 */
	ai_original_image_id?: number
	/**
	 * type of device being viewed
	 */
	device_type?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Tracking the feature where the image was uploaded
	 */
	feature?: string
	/**
	 * Size of the file being uploaded
	 */
	file_size_mb?: number
	/**
	 * Type of the file being uploaded (eg. jpg, png, jpeg)
	 */
	file_type?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Time taken (in milliseconds) for the initial request to Hyperion for a placeholder ai_original_image record
	 */
	hyperion_placeholder_ms?: number
	/**
	 * Time taken (in milliseconds) for the request to Hyperion to associate an uploaded image with a placeholder ai_original_image
	 */
	hyperion_response_ms?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * Page or screen name where the image was uploaded
	 */
	page_or_screen_name?: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * The timestamp (in milliseconds) of the initial request to kick off the upload process
	 */
	request_timestamp_ms?: number
	/**
	 * The timestamp (in milliseconds) of the final response ending a successful upload process
	 */
	response_timestamp_ms?: number
	/**
	 * ID to track events triggered by anonymous users
	 */
	session_id?: string
	/**
	 * Total upload time (in milliseconds) of the entire upload process, from the perspective of the user
	 */
	total_upload_time_ms?: number
	/**
	 * Supplemental tracking identifier for the situation where an image is being uploaded
	 */
	track_id: string
	/**
	 * Time (in milliseconds) taken to upload the file directly from the client to a cloud service provider
	 */
	upload_to_cloud_ms?: number
	/**
	 * Indicates if the event was triggered from an anonymous user or not
	 */
	user_authenticated?: boolean
	/**
	 * Hyperion user ID
	 */
	user_id?: number
}
export interface InputPressed {
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * The label of the input
	 */
	input_label?: string
	/**
	 * The Hyperion org_id
	 */
	org_id?: number
	org_name?: string
	page_or_screen_name?: string
	user_email?: string
	/**
	 * The Hyperion user id
	 */
	user_id?: number
}
export interface InsuranceIdentified {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button or link, likely replaced button_text.
	 */
	button_or_link_text?: string | null
	/**
	 * The text on the button.
	 */
	button_text?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface LinkImpression {
	/**
	 * Id of display image in Homeowner App
	 */
	ai_display_image_id?: number
	/**
	 * Id of generated image in Homeowner App
	 */
	ai_generated_image_id?: number
	/**
	 * Id of original image in Homeowner App
	 */
	ai_original_image_id?: number
	/**
	 * Database object name associated with this event
	 */
	backend_id_type?: string
	/**
	 * Database object id associated with this event
	 */
	backend_id_value?: string
	/**
	 * The Design Studio mode the user is currently in
	 */
	design_studio_mode?: string
	/**
	 * The destination url for the link pressed
	 */
	destination_url?: string
	/**
	 * Type of device being viewed
	 */
	device_type?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The Hyperion job id
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * The location of the link on the page or screen.
	 */
	link_location?: string
	/**
	 * The text on the link.
	 */
	link_text: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the link was pressed.
	 */
	page_or_screen_name: string
	/**
	 * The Partner if link is embedded with in a Partner specific page context
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * mobile or web
	 */
	platform_type?: string
	/**
	 * Whether the link is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
	/**
	 * ID of the Gen AI project
	 */
	project_id?: number
	/**
	 * The manufacturer of the product/material
	 */
	provider_name?: string
	/**
	 * The input that is being searched as part of Google search link
	 */
	search_query?: string
	/**
	 * ID to track events triggered during a single session
	 */
	session_id?: string
	/**
	 * Static id for tracking link
	 */
	track_id?: string
	/**
	 * Indicates if the event was triggered for an anonymous user or a logged in user.
	 */
	user_authenticated?: boolean
	/**
	 * User's email
	 */
	user_email?: string
	/**
	 * Hyperion user ID
	 */
	user_id?: number
}
export interface LinkPressed {
	/**
	 * Id of display image in Homeowner App
	 */
	ai_display_image_id?: number
	/**
	 * Id of generated image in Homeowner App
	 */
	ai_generated_image_id?: number
	/**
	 * Id of original image in Homeowner App
	 */
	ai_original_image_id?: number
	/**
	 * Database object name associated with this event
	 */
	backend_id_type?: string
	/**
	 * Database object id associated with this event
	 */
	backend_id_value?: string
	/**
	 * The Design Studio mode the user is currently in
	 */
	design_studio_mode?: string
	/**
	 * The destination url for the link pressed
	 */
	destination_url?: string
	/**
	 * Type of device being viewed
	 */
	device_type?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The Hyperion job id
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * The location of the link on the page or screen.
	 */
	link_location?: string
	/**
	 * The text on the link.
	 */
	link_text: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the link was pressed.
	 */
	page_or_screen_name: string
	/**
	 * The Partner if link is embedded with in a Partner specific page context
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * mobile or web
	 */
	platform_type?: string
	/**
	 * Whether the link is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
	/**
	 * ID of the Gen AI project
	 */
	project_id?: number
	/**
	 * The manufacturer of the product/material
	 */
	provider_name?: string
	/**
	 * The input that is being searched as part of Google search link
	 */
	search_query?: string
	/**
	 * ID to track events triggered during a single session
	 */
	session_id?: string
	/**
	 * Static id for tracking link
	 */
	track_id?: string
	/**
	 * Indicates if the event was triggered for an anonymous user or a logged in user.
	 */
	user_authenticated?: boolean
	/**
	 * User's email
	 */
	user_email?: string
	/**
	 * Hyperion user ID
	 */
	user_id?: number
}
export interface LoginSsoStarted {
	/**
	 * Whether the element pressed was a button or a link.
	 */
	button_or_link: string
	/**
	 * The location of the button or link on the page or screen.
	 */
	button_or_link_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface LoginStarted {
	/**
	 * Whether the element pressed was a button or a link.
	 */
	button_or_link: string
	/**
	 * The location of the button on the page or screen.
	 */
	button_or_link_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface ModalViewed {
	/**
	 * A boolean indicating whether the user is using dense for the current capture
	 */
	dense_guidance_capture?: boolean
	/**
	 * A boolean indicating whether dense is enabled for the camera.
	 */
	dense_guidance_enabled_for_camera?: boolean
	/**
	 * A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
	 */
	dense_guidance_mode?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * The client identifier of the Job the user is capturing.
	 */
	job_client_identifier?: string
	/**
	 * the name of a job deliverable, such as "capture only", "complete", etc
	 */
	job_deliverable?: string
	/**
	 * The name of the modal.
	 */
	name?: string
	/**
	 * A unique id to identify the artifact being viewed in the modal
	 */
	output_id?: string
	/**
	 * The page or screen name where the modal was viewed
	 */
	page_or_screen_name?: string
	/**
	 * Supplementary tracking identifier for the specific instance where the modal was viewed
	 */
	track_id?: string
}
export interface ModelComponentSelected {
	/**
	 * Database object name associated with this event
	 */
	backend_id_type?: string
	/**
	 * Database object value associated with this event
	 */
	backend_id_value?: string
	/**
	 * The Hyperion Job Id
	 */
	job_id?: number
	/**
	 * Where does this model component appear
	 */
	page_or_screen_name?: string
	/**
	 * Is this field the primary cta
	 */
	primary_cta?: boolean
	/**
	 * Id of the user
	 */
	user_id?: number
}
export interface ModelInteracted {
	/**
	 * The Design Studio mode the user is currently in
	 */
	design_studio_mode?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * If Design Studio is embedded in an iframe, this value will show if the model interacted event happened while the iframe is in fullscreen mode
	 */
	fullscreen_iframe?: boolean
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * If Design Studio is embedded in an iframe, this is the "location" of the iframe (e.g. hover_property-details-page, james-hardie_homepage, unknown, etc...). This property needs to be manually set as a URL param in the iframe src url.
	 */
	iframe_location?: string
	/**
	 * The type of interaction the user made. Possible values are "rotate", "pan", or "zoom".
	 */
	interaction_type: string
	/**
	 * The Hyperion Job Id.
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
}
export interface ModuleViewed {
	/**
	 * ID of the relevant AIDisplayImage
	 */
	ai_display_image_id?: number
	/**
	 * ID of the relevant AIGeneratedImage
	 */
	ai_generated_image_id?: number
	/**
	 * Whether an image was watermarked
	 */
	ai_image_watermarked?: boolean
	/**
	 * ID of the relevant AIDisplayImage
	 */
	ai_original_image_id?: number
	/**
	 * The color group from a color selected that was not defined in texture details, "Popular", "Statement", "Reds", etc...
	 */
	color_group?: string
	/**
	 * The hexadecimal representation of the color selected. For example, "#ffffff", "#ebdec4", "#ddb582", etc...
	 */
	color_hex?: string
	/**
	 * The name of the color selected. For example generic names "Reds" and "Greens", or branded names "Rustic Barn", "Wintery White", etc...
	 */
	color_name?: string
	/**
	 * Type of device being viewed
	 */
	device_type?: string
	/**
	 * The region being edited
	 */
	edit_region?: string
	/**
	 * The type of edit (paint, walls, roof, etc)
	 */
	edit_type?: string
	/**
	 * The name of the associated feature
	 */
	feature?: string
	/**
	 * The Hyperion Job ID
	 */
	job_id?: number
	/**
	 * Manufacturer of product
	 */
	manufacturer?: string
	/**
	 * User's org ID
	 */
	org_id?: number
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name?: string
	/**
	 * The Partner if button is embedded with in a Partner specific page context
	 */
	partner_id?: number
	/**
	 * ID of the relevant Project
	 */
	project_id?: number
	/**
	 * ID to track events triggered by anonymous users
	 */
	session_id?: string
	/**
	 * Space type of uploaded image in Homeowner App
	 */
	space_type?: string
	/**
	 * Style of image or design
	 */
	style?: string
	/**
	 * Static track id for module viewed
	 */
	track_id?: string
	/**
	 * Used to track if an event is triggered by an anonymous users
	 */
	user_authenticated?: boolean
	/**
	 * The Hyperion Job ID
	 */
	user_id?: number
}
export interface OptionSelected {
	/**
	 * Database object name associated with this event
	 */
	backend_id_type?: string
	/**
	 * Database object value associated with this event
	 */
	backend_id_value?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Name of associated feature

	 */
	feature?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The Hyperion Job Id
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * The type of frontend selector (radio, dropdown)
	 */
	option_type?: string
	/**
	 * The description of the set of options
	 */
	options: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * Where does this select appear
	 */
	page_or_screen_name?: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Is this field the primary CTA
	 */
	primary_cta?: boolean
	/**
	 * The thing being selected
	 */
	selection: string
	/**
	 * Supplementary tracking identifier for the specific instance of an option being selected
	 */
	track_id?: string
	user_email?: string
	/**
	 * Id of the user
	 */
	user_id?: number
}
export interface PageViewed {
	/**
	 * Whether account type is unified/combined or not.
See: #4961
	 */
	account_type_combined?: boolean
	/**
	 * The Design Studio mode the user is currently in
	 */
	design_studio_mode?: string
	duration_loading?: string
	/**
	 * For error screens, the reason the user is seeing this particular error
	 */
	failure_reason?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * Whether personal information page (combined) is displayed or not for the onboarding phase v1.
	 * See OnboardingTests type for more details.
	 */
	include_self_qual?: boolean
	/**
	 * name deliverable type (complete, roof_only, etc)
	 */
	job_deliverable?: string
	/**
	 * The Hyperion Job Id.
	 */
	job_id?: number
	/**
	 * the name of the property/project/job
	 */
	job_name?: string
	/**
	 * the state of the job (FAILED, COMPLETE, PENDING, etc)
	 */
	job_state?: string
	/**
	 * Combined value refers to the unified page to fill out name, company name and phone number (see UserPersonalInformation component).
	 * Separated value refers to the separated pages to fill out the same information.
	 */
	onboarding_test?: string
	org_id?: number
	org_name?: string
	/**
	 * The name of the page.
	 */
	page_or_screen_name?: string
	/**
	 * Partner specific page
	 */
	partner_id?: number
	/**
	 * mobile or web
	 */
	platform_type?: string
	/**
	 * ID of the org owning the pro page.
	 */
	pro_page_org_id?: number
	/**
	 * ID of a production list from the ehi code base
	 */
	production_list_id?: number
	/**
	 * The Document.referrer property from the URI of the web page
	 */
	referrer?: string
	/**
	 * ID to track events triggered during a single session
	 */
	session_id?: string
	/**
	 * Key for the tracked event
	 */
	track_id?: string
	user_email?: string
	user_id?: number
}
export interface PinchedZoom {
	ai_displayed_image_id?: string
	ai_generated_image_id?: number
	/**
	 * Whether an image was watermarked
	 */
	ai_image_watermarked?: boolean
	ai_original_image_id?: number
	/**
	 * Selected color group
	 */
	color_group?: string
	/**
	 * Selected color value
	 */
	color_hex?: string
	device_type?: string
	/**
	 * Associated feature
	 */
	feature?: string
	/**
	 * Manufacture's name of applied product
	 */
	manufacturer?: string
	org_id?: number
	page_or_screen_name?: string
	partner_id?: number
	session_id?: string
	space_type?: string
	/**
	 * Style used to generate image
	 */
	style?: string
	track_id: string
	user_authenticated?: boolean
	user_id?: number
}
export interface ProductSelected {
	/**
	 * Id of display image in Homeowner App
	 */
	ai_display_image_id?: number
	/**
	 * Id of generated image in Homeowner App
	 */
	ai_generated_image_id?: number
	/**
	 * Id of original image uploaded by user in Homeowner App
	 */
	ai_original_image_id?: number
	/**
	 * The category of product selected. For example, "Walls", "Roof", "Trim", etc...
	 */
	category?: string | null
	/**
	 * The color group from a color selected that was not defined in texture details, "Popular", "Statement", "Reds", etc...
	 */
	color_group?: string | null
	/**
	 * The hexadecimal representation of the color selected. For example, "#ffffff", "#ebdec4", "#ddb582", etc...
	 */
	color_hex?: string | null
	/**
	 * The name of the color selected. For example generic names "Reds" and "Greens", or branded names "Rustic Barn", "Wintery White", etc...
	 */
	color_name?: string | null
	/**
	 * The Design Studio mode the user is currently in
	 */
	design_studio_mode?: string
	/**
	 * Type of device being viewed
	 */
	device_type?: string
	/**
	 * The region being edited
	 */
	edit_region?: string
	/**
	 * The type of edit (paint, walls, roof, etc)
	 */
	edit_type?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * The parametric frame type for a window selected (will only be present if the product selected is a window). For example "casement" or "slider"...
	 */
	frame?: string | null
	/**
	 * The parametric grid type for a window selected (will only be present if the product selected is a window). For example "diamond" or "farmhouse"...
	 */
	grid?: string | null
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The Hyperion Job Id.
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Manufacturer of product
	 */
	manufacturer?: string
	/**
	 * The number of material classes edited by the selection
	 */
	material_classes_edited?: number
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the product was selected.
	 */
	page_or_screen_name: string
	/**
	 * The parameter of the product the user selected. For example, “Roofing Types”, “Style”, etc..
	 */
	parameter: string | null
	/**
	 * The Partner if button is embedded with in a Partner specific page context
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * The kind of product the user selected. For example, "Walls", "Roof", "Trim", etc..
	 */
	product: string | null
	/**
	 * Grouping of the product selected
	 */
	product_group?: string
	/**
	 * Name of the product selected
	 */
	product_name?: string
	/**
	 * The type of texture. For example "horizontal", "stone", "asphalt", "brick", etc...
	 */
	product_type?: string | null
	/**
	 * The option the user selected. For example, “Metal”, “Standing Seam”, etc..
	 */
	selection: any | null
	/**
	 * What type of selection (first generation or re-generate)
	 */
	selection_type?: string | null
	/**
	 * ID to track events triggered during a single session
	 */
	session_id?: string
	/**
	 * Space type of uploaded image in Homeowner App
	 */
	space_type?: string
	/**
	 * Style of image or design
	 */
	style?: string
	/**
	 * The color group assigned with the other texture properties. For example "Beiges", "Reds", etc...
	 */
	texture_color_group?: string | null
	/**
	 * The id of the texture selected.
	 */
	texture_id?: number | null
	/**
	 * The name of texture color, typically a duplicate of texture_color_group
	 */
	texture_name?: string | null
	/**
	 * The shape of the texture. For example "Straight Shake", "Staggered Shake", "Scalloped", etc...
	 */
	texture_shape?: string | null
	/**
	 * The size of the selected texture. For example `3"`, `4"`, `4.5"`, etc...
	 */
	texture_size?: string | null
	/**
	 * The style of the selected texture. For example "Dutch Lap", "Board and Batten", etc...
	 */
	texture_style?: string | null
	/**
	 * The type of texture. For example "Cedarmill" or "Smooth"
	 */
	texture_type?: string | null
	/**
	 * Static track id for product selected
	 */
	track_id?: string
	/**
	 * Indicates if the event was triggered for an anonymous user or a logged in user.
	 */
	user_authenticated?: boolean
	/**
	 * user's id
	 */
	user_id?: number
}
export interface ProfessionalIdentified {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button or link, likely replaced button_text.
	 */
	button_or_link_text?: string | null
	/**
	 * The text on the button.
	 */
	button_text?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface PropertyPressed {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Whether the property is an example job.
	 */
	example_job?: boolean
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface RequestFormOpened {
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * The ID of the job for which the rendering is for
	 */
	job_id?: number
	/**
	 * The Org of the requesting user
	 */
	org_id?: number
	rendering_id?: string
	/**
	 * Static track id for button
	 */
	track_id?: string
}
export interface SavedImage {
	/**
	 * ID of the relevant AIGeneratedImage
	 */
	ai_generated_image_id?: number
	/**
	 * ID of the relevant AiOriginalImage
	 */
	ai_original_image_id?: number
	/**
	 * Type of device being viewed
	 */
	device_type?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * Type of image being saved (i.e. edited or generated)
	 */
	image_type?: string | null
	/**
	 * Org Id of user
	 */
	org_id?: number
	/**
	 * The name of the page or screen when the event was triggered.
	 */
	page_or_screen_name?: string
	/**
	 * Partner Id associated with the user
	 */
	partner_id?: number
	/**
	 * Project Id that image is being saved to
	 */
	project_id?: number
	/**
	 * Where the image is being saved (e.g. Project or Saved ideas)
	 */
	save_to?: string | null
	/**
	 * ID to track events triggered during a single session
	 */
	session_id?: string
	/**
	 * Static track id for event
	 */
	track_id?: string
	/**
	 * Indicates if the event was triggered for an anonymous user or a logged in user.
	 */
	user_authenticated?: boolean
	/**
	 * User's Hyperion Id
	 */
	user_id?: number
}
export interface ScreenViewed {
	/**
	 * A boolean indicating whether the user is using dense for the current capture
	 */
	dense_guidance_capture?: boolean
	/**
	 * A boolean indicating whether dense is enabled for the camera.
	 */
	dense_guidance_enabled_for_camera?: boolean
	/**
	 * A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
	 */
	dense_guidance_mode?: string
	/**
	 * The client identifier of the Job the user is capturing.
	 */
	job_client_identifier?: string
}
export interface SessionStarted {
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * The url of the parent window that the application is embedded at.
	 */
	embedded_at?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The Hyperion Job Id
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * ID to track events triggered during a single session
	 */
	session_id: string
	/**
	 * The Split key identifying the user
	 */
	split_key?: string
	/**
	 * Id of the user
	 */
	user_id?: number
}
export interface SettingChanged {
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * The name of the setting.
	 */
	setting_text: string
	/**
	 * The value the setting was changed to.
	 */
	value: any | null
}
export interface SignupStarted {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * Whether the element pressed was a button or a link.
	 */
	button_or_link: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface SupportContacted {
	/**
	 * Whether the element pressed was a button or a link.
	 */
	button_or_link: string
	/**
	 * The location of the button or link on the page or screen.
	 */
	button_or_link_location?: string
	/**
	 * The text on the button or link.
	 */
	button_or_link_text: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface Swipe {
	/**
	 * ID of the relevant AiGeneratedImage
	 */
	ai_generated_image_id?: number
	/**
	 * ID of the relevant AiOriginalImage
	 */
	ai_original_image_id?: number
	/**
	 * Direction of the swipe
	 */
	direction?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The Hyperion job id
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * The Hyperion org id
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * The name of the page or screen where the user swiped
	 */
	page_or_screen_name: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * Session id used to track events for anonymous users
	 */
	session_id?: string
	/**
	 * Style of image being swiped through
	 */
	style?: string
	/**
	 * Static track id for swipe
	 */
	track_id?: string
	/**
	 * Indicates if the event was triggered from an anonymous user or not
	 */
	user_authenticated?: boolean
	/**
	 * The Hyperion user id
	 */
	user_id?: number
}
export interface TabViewed {
	button_location?: string
	/**
	 * The Design Studio mode the user is currently in
	 */
	design_studio_mode?: string
	/**
	 * Name of associated feature
	 */
	feature?: string
	/**
	 * The Hyperion Job Id.
	 */
	job_id?: number
	/**
	 * The name of the page.
	 */
	page_or_screen_name?: string
	/**
	 * Partner specific page
	 */
	partner_id?: number
}
export interface TextInput {
	/**
	 * Database object name associated with this event
	 */
	backend_id_type?: string
	/**
	 * Database object value associated with this event
	 */
	backend_id_value?: string
	/**
	 * Email address of a user
	 */
	email?: string
	/**
	 * First name of a user
	 */
	first_name?: string
	/**
	 * Whether the user is a Homeowner
	 */
	homeowner?: boolean
	/**
	 * The label of the text input.
	 */
	input_label?: string
	/**
	 * The location of the input on the page or screen.
	 */
	input_location?: string
	/**
	 * The value of the text input.
	 */
	input_value: string
	/**
	 * The Hyperion Job Id
	 */
	job_id?: number
	/**
	 * Last name of a user
	 */
	last_name?: string
	/**
	 * Org Id of a user
	 */
	org_id?: number
	/**
	 * Org Name of a user
	 */
	org_name?: string
	/**
	 * Where does this text input appear
	 */
	page_or_screen_name?: string
	/**
	 * Partner Id of a user
	 */
	partner_id?: number
	/**
	 * Partner Name of a user
	 */
	partner_name?: string
	/**
	 * mobile or web
	 */
	platform_type?: string
	/**
	 * template id from ehi code base
	 */
	template_id?: number
	/**
	 * template name from ehi code base
	 */
	template_name?: string
	/**
	 * trade type from ehi code base
	 */
	trade_type?: string
	user_email?: string
	user_id?: number
}

export type ViolationHandler = (
	message: Record<string, any>,
	violations: any[]
) => void

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler: ViolationHandler = (
	message,
	violations
) => {
	const msg = JSON.stringify(
		{
			type: 'Typewriter JSON Schema Validation Error',
			description:
				`You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
				'Tracking Plan spec.',
			errors: violations,
		},
		undefined,
		2
	)

	console.warn(msg)
}

let analytics: () => SegmentAnalytics.AnalyticsJS | undefined = () => {
	return window.analytics
}

/** Options to customize the runtime behavior of a Typewriter client. */
export interface TypewriterOptions {
	/**
	 * Underlying analytics instance where analytics calls are forwarded on to.
	 * Defaults to window.analytics.
	 */
	analytics?: SegmentAnalytics.AnalyticsJS
	/**
	 * Handler fired when if an event does not match its spec. This handler
	 * does not fire in production mode, because it requires inlining the full
	 * JSON Schema spec for each event in your Tracking Plan.
	 *
	 * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
	 * if a message does not match the spec. Otherwise, errors will be logged to stderr.
	 */
	onViolation?: ViolationHandler
}

/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options: TypewriterOptions) {
	analytics = options.analytics
		? () => options.analytics || window.analytics
		: analytics
}

/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message: Segment.Options = {}): Segment.Options {
	return {
		...message,
		context: {
			...(message.context || {}),
			typewriter: {
				language: 'typescript',
				version: '7.4.1',
			},
		},
	}
}

/**
 * @typedef AccountCreated
 * @property {string} button_or_link - Whether the element pressed was a button or a link.
 * @property {string} [button_or_link_location] - The location of the button or link on the page or screen.
 * @property {string} [button_or_link_text] - The text on the button or link.
 * @property {string} [email] - Email address of a user
 * @property {Record<string, any>} [experiments] - Split experiments and treatment that the user is assigned to
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {string | null} [platform_type] - The platform on which the user signed up. For example, mobile or web.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 * @property {string} [session_id] - ID to track events triggered during a single session
 * @property {number} [user_id] -
 */
/**
 * @typedef AgreedToTosPrivacy
 * @property {string} [checkbox_location] - The location of the checkbox on the page or screen.
 * @property {string} [email] - Email address of a user
 * @property {string} [feature] - The feature for which the TOS/Privacy was agreed to
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 * @property {string} [track_id] - Supplementary tracking identifier for the specific instance where the TOS/Privacy have been agreed to
 */
/**
 * @typedef BackButtonPressed
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} [design_studio_mode] - The current Design Studio mode
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - The Partner if button is embedded with in a Partner specific page context
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef ButtonImpression
 * @property {number} [ai_display_image_id] - Id of display image in Homeowner App
 * @property {number} [ai_generated_image_id] - Id of generated image in Homeowner App
 * @property {number} [ai_original_image_id] - Id of original image uploaded by user in Homeowner App
 * @property {string} [backend_id_type] - Database object name associated with this event
 * @property {string} [backend_id_value] - Database object id associated with this event
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} [button_type] -
 * @property {boolean} [dense_guidance_capture] - A boolean indicating whether the user is using dense for the current capture
 * @property {boolean} [dense_guidance_enabled_for_camera] - A boolean indicating whether dense is enabled for the camera.
 * @property {string} [dense_guidance_mode] - A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
 * @property {string} [design_studio_mode] - The Design Studio mode the user is currently in
 * @property {string} [email] - Email address of a user
 * @property {string} [feature] - Name of associated feature
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [item_type] - The domain object being operated on
 * @property {string} [job_client_identifier] - The client identifier of the Job the user is capturing.
 * @property {number} [job_id] - The Hyperion Job Id.
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} [primary_cta] - Whether the button is the primary call to action on the page or screen.
 * @property {string} [provider_name] -
 * @property {string | null} [space_type] - Space type of uploaded image in Homeowner App
 * @property {string} [style] - Style of generated image in Homeowner App
 * @property {number} [total_material_classes] - Total number of edit material classes in Gen AI
 * @property {string} [track_id] - Static track id for button
 * @property {string} [view_type] - View type in Homeowner App (e.g. grid-view, full-screen-view)
 */
/**
 * @typedef ButtonPressed
 * @property {number} [ai_display_image_id] - ID of the relevant AIDisplayImage
 * @property {number} [ai_generated_image_id] - ID of the relevant AIGeneratedImage
 * @property {boolean} [ai_image_watermarked] - Whether an image was watermarked
 * @property {number} [ai_original_image_id] - ID of the relevant AiOriginalImage
 * @property {string} [backend_id_type] - Database object name associated with this event
 * @property {string} [backend_id_value] - Database object id associated with this event
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} [button_type] -
 * @property {string} [color_group] - The color group from a color selected that was not defined in texture details, "Popular", "Statement", "Reds", etc...
 * @property {string} [color_hex] - The hexadecimal representation of the color selected. For example, "#ffffff", "#ebdec4", "#ddb582", etc...
 * @property {string} [color_name] - The name of the color selected. For example generic names "Reds" and "Greens", or branded names "Rustic Barn", "Wintery White", etc...
 * @property {boolean} [dense_guidance_capture] - A boolean indicating whether the user is using dense for the current capture
 * @property {boolean} [dense_guidance_enabled_for_camera] - A boolean indicating whether dense is enabled for the camera.
 * @property {string} [dense_guidance_mode] - A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
 * @property {string} [device_type] - Type of device being viewed
 * @property {string} [edit_region] - The region being edited
 * @property {string} [edit_type] - The type of edit (paint, walls, roof, etc)
 * @property {number} [edited_image_id] - The generated image id of the edited image.
 * @property {string} [email] - Email address of a user
 * @property {string} [feature] - Name of associated feature
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [images_saved] - The number of images that are saved to projects
 * @property {string} [item_type] - The domain object being operated on
 * @property {string} [job_client_identifier] - The client identifier of the Job the user is capturing.
 * @property {string} [job_deliverable] - the name of a job deliverable, such as "capture only", "complete", etc
 * @property {number | null} [job_id] - The Hyperion Job Id.
 * @property {string} [last_name] - Last name of a user
 * @property {string} [manufacturer] - Manufacturer of product
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} [org_type] - Insurance or pro
 * @property {string} [output_id] - unique id of the relevant piece of content for this button (e.g. an image_id for a download button for that image)
 * @property {string} [page_or_screen_name] - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - The Partner if button is embedded with in a Partner specific page context
 * @property {string} [partner_name] - Partner Name of a user
 * @property {string} [platform_type] - mobile or web
 * @property {boolean} [primary_cta] - Whether the button is the primary call to action on the page or screen.
 * @property {string} [product_group] - Name of the product selected
 * @property {string} [product_name] - Name of the product selected
 * @property {number} [project_id] - ID of the project
 * @property {string} [project_name] - Name of the Gen AI project
 * @property {string} [provider_name] - The manufacturer of the product/material
 * @property {Record<string, any>} [save_as_template_details] - details on actions for save_as_template feature in EHI
 * @property {string} [session_id] - ID to track events triggered during a single session
 * @property {string} [space_type] - Space type of uploaded image in Homeowner App
 * @property {string} [style] - Style of image or design
 * @property {number} [total_material_classes] - Total number of edit material classes in Gen AI
 * @property {string} [track_id] - Static track id for button
 * @property {string} [trade] - trade type from ehi codebase
 * @property {boolean} [user_authenticated] - Indicates if the event was triggered for an anonymous user or a logged in user.
 * @property {string} [user_email] - user's email
 * @property {number} [user_id] - Hyperion user ID
 * @property {string} [view_type] - View type in Homeowner App (e.g. grid-view, full-screen-view)
 */
/**
 * @typedef CaptureStarted
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} job_client_identifier - The client identifier of the Job the user is capturing.
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.

 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef CaptureSubmitted
 * @property {string} [button_location] - The location of the button on the page or screen.

 * @property {string} button_text - The text on the button.

 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} job_client_identifier - The client identifier of the Job the user is capturing.
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.

 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 * @property {boolean} [progressive_upload] - Progressive Uploads was enabled for the capture.
 */
/**
 * @typedef CheckboxSelected
 * @property {string} [backend_id_type] - Database object name associated with this event
 * @property {string} [backend_id_value] - Database object value associated with this event
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [job_id] - The Hyperion Job Id
 * @property {string} [last_name] - Last name of a user
 * @property {string} options - The description of the set of options
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} [page_or_screen_name] - Where does this checkbox appear
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} [primary_cta] - Is this field the primary CTA
 * @property {string} selection - The thing being selected
 * @property {string} [user_email] - user's email
 * @property {number} [user_id] - Id of the user
 */
/**
 * @typedef CheckboxToggled
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {boolean} checked - Value of checkbox
 * @property {boolean} [dense_guidance_capture] - A boolean indicating whether the user is using dense for the current capture
 * @property {boolean} [dense_guidance_enabled_for_camera] - A boolean indicating whether dense is enabled for the camera.
 * @property {string} [dense_guidance_mode] - A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
 * @property {string} [design_studio_mode] - The Design Studio mode the user is currently in
 * @property {string} [email] - Email address of a user
 * @property {string} [feature] - Name of associated feature
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [job_client_identifier] - The client identifier of the Job the user is capturing.
 * @property {number} [job_id] - The Hyperion Job Id.
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - The Partner if button is embedded with in a Partner specific page context
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 * @property {number} [template_id] - template id from ehi code base
 * @property {string} [template_name] - template name from ehi code base
 * @property {string} [track_id] - Static track id for button
 * @property {string} [trade_type] - trade type enum from ehi code base
 * @property {string} [user_email] -
 * @property {number} [user_id] -
 */
/**
 * @typedef DataSaved
 * @property {string} [backend_id_type] - The backend id type of the item represented by the saved data.
 * @property {string} [backend_id_value] - The backend id value of the item represented by the saved data.
 * @property {string} [feature] - The feature that the saved data is associated with.
 * @property {string} [input_label] - the label of input used to save data (see inputPressed event for parallel field)
 * @property {string} [item_type] - The item/object type that the saved data is associated with.
 * @property {string} [page_or_screen_name] - The page or screen where the save occurred.
 * @property {number} [parent_id] - The parent item/object id that the saved data is associated with. This could be a `job`, `estimate`, `sales_opportunity`, etc.
 * @property {Record<string, any>} [saved_data] - The data payload of the saved data.
 */
/**
 * @typedef DenseCaptureStarted
 * @property {boolean} dense_guidance_capture - A boolean indicating whether the user is using dense for the current capture
 * @property {boolean} dense_guidance_enabled_for_camera - A boolean indicating whether dense is enabled for the camera.
 * @property {string} dense_guidance_mode - A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [job_client_identifier] - The client identifier of the Job the user is capturing.
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.

 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 */
/**
 * @typedef ElementDragged
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [job_id] -
 * @property {string} [last_name] - Last name of a user
 * @property {string} name -
 * @property {number} new_position -
 * @property {number} old_position -
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} [page_or_screen_name] -
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {string} [user_email] -
 * @property {number} [user_id] -
 */
/**
 * @typedef ElementViewed
 * @property {string} [design_studio_mode] - The Design Studio mode the user is currently in
 * @property {string} [element_name] - Name of the element that was viewed
 * @property {string} [feature] - Name of associated feature
 * @property {number} [job_id] - The Hyperion Job Id.
 * @property {number} [lifetime_xactimate_successful_submission] - The total number of successful Xactimate Guided Estimates submissions for the user
 * @property {string} [page_or_screen_name] - Name of page
 * @property {number} [partner_id] - Partner specific page
 * @property {string} [track_id] - Key for the tracked event
 * @property {string} [user_email] -
 * @property {number} [user_id] -
 */
/**
 * @typedef Error
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {string} [message] - the error message displayed to users
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {number} [status] - HTTP status code e.g. 401
 * @property {string} type - what kind of error
 */
/**
 * @typedef FeatureUpvoted
 * @property {string} [email] - Email address of a user
 * @property {string} feature - The name of the feature the user upvoted.
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [job_id] - The Hyperion Job Id.
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the feature was upvoted.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 */
/**
 * @typedef HomeownerIdentified
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string | null} [button_or_link_text] - The text on the button or link, likely replaced button_text.
 * @property {string} [button_text] - The text on the button.
 * @property {string} [email] - Email address of a user
 * @property {Record<string, any>} [experiments] - Split experiments and treatment that the user is assigned to
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef ImageClicked
 * @property {number} [ai_generated_image_id] - ID of the relevant AiGeneratedImage
 * @property {number} [ai_original_image_id] - ID of the relevant AiOriginalImage
 * @property {string} [device_type] - Device type the image was clicked on
 * @property {string} [feature] - Name of associated feature
 * @property {number} [org_id] - The Hyperion org_id
 * @property {string} [output_id] - Supplemental tracking id to track which image was clicked
 * @property {string} [page_or_screen_name] - The name of the page or screen where the image was clicked.
 * @property {string} [session_id] - ID to track events triggered by anonymous users
 * @property {string} [space_type] - Space type of the image clicked
 * @property {string} [style] - Style of the image clicked
 * @property {string} [track_id] - Unique id to track this event
 * @property {boolean} [user_authenticated] - Indicates if the event was triggered from an anonymous user or not
 * @property {number} [user_id] - The Hyperion user_id
 */
/**
 * @typedef ImageLoaded
 * @property {number} [ai_generated_image_id] - ID of the relevant AiGeneratedImage
 * @property {boolean} [ai_image_watermarked] - Whether an AI generated image was watermarked
 * @property {number} [ai_original_image_id] - Original image ID
 * @property {string} [device_type] - type of device being viewed
 * @property {string} [feature] - Tracking the feature where the image was loaded
 * @property {string} [image_generation_type] - Identifies the method used to generate the image
 * @property {boolean} [is_generation_request] - Identifies whether this image load event is a generation request
 * @property {number} [loading_time_ms] - Optional tracking field to track total latency (in milliseconds) as an alternative to tracking the request and response timestamps
 * @property {number} [org_id] - Hyperion org ID
 * @property {string} [output_id] - Unique id for each image
 * @property {string} [page_or_screen_name] - Page or screen name where the image was loaded
 * @property {number} [partner_id] - Hyperion partner ID
 * @property {number} [request_timestamp_ms] - the time (in milliseconds) when the image was requested
 * @property {number} [response_timestamp_ms] - the time (in milliseconds) when the image response was loaded
 * @property {string} [sample_image_path] - Path for the sample image loaded (used as unique identifier)
 * @property {number} [server_loading_time_ms] - the time (in milliseconds) for image generation on server
 * @property {string} [session_id] - ID to track events triggered by anonymous users
 * @property {string} [space_type] - Space type of the image that was loaded
 * @property {string} [style] - Image style
 * @property {string} [track_id] - Supplemental tracking identifier for the situation where an image is being loaded
 * @property {boolean} [user_authenticated] - Indicates if the event was triggered from an anonymous user or not
 * @property {number} [user_id] - Hyperion user ID
 * @property {boolean} [went_offline] - Indicates if user has went offline during loading of image
 */
/**
 * @typedef ImageUploaded
 * @property {number} [ai_original_image_id] - ID of the relevant AiGeneratedImage
 * @property {string} [device_type] - type of device being viewed
 * @property {string} [email] - Email address of a user
 * @property {string} [feature] - Tracking the feature where the image was uploaded
 * @property {number} [file_size_mb] - Size of the file being uploaded
 * @property {string} [file_type] - Type of the file being uploaded (eg. jpg, png, jpeg)
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [hyperion_placeholder_ms] - Time taken (in milliseconds) for the initial request to Hyperion for a placeholder ai_original_image record
 * @property {number} [hyperion_response_ms] - Time taken (in milliseconds) for the request to Hyperion to associate an uploaded image with a placeholder ai_original_image
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} [page_or_screen_name] - Page or screen name where the image was uploaded
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {number} [request_timestamp_ms] - The timestamp (in milliseconds) of the initial request to kick off the upload process
 * @property {number} [response_timestamp_ms] - The timestamp (in milliseconds) of the final response ending a successful upload process
 * @property {string} [session_id] - ID to track events triggered by anonymous users
 * @property {number} [total_upload_time_ms] - Total upload time (in milliseconds) of the entire upload process, from the perspective of the user
 * @property {string} track_id - Supplemental tracking identifier for the situation where an image is being uploaded
 * @property {number} [upload_to_cloud_ms] - Time (in milliseconds) taken to upload the file directly from the client to a cloud service provider
 * @property {boolean} [user_authenticated] - Indicates if the event was triggered from an anonymous user or not
 * @property {number} [user_id] - Hyperion user ID
 */
/**
 * @typedef InputPressed
 * @property {string} [feature] - Name of associated feature
 * @property {string} [input_label] - The label of the input
 * @property {number} [org_id] - The Hyperion org_id
 * @property {string} [org_name] -
 * @property {string} [page_or_screen_name] -
 * @property {string} [user_email] -
 * @property {number} [user_id] - The Hyperion user id
 */
/**
 * @typedef InsuranceIdentified
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string | null} [button_or_link_text] - The text on the button or link, likely replaced button_text.
 * @property {string} [button_text] - The text on the button.
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef LinkImpression
 * @property {number} [ai_display_image_id] - Id of display image in Homeowner App
 * @property {number} [ai_generated_image_id] - Id of generated image in Homeowner App
 * @property {number} [ai_original_image_id] - Id of original image in Homeowner App
 * @property {string} [backend_id_type] - Database object name associated with this event
 * @property {string} [backend_id_value] - Database object id associated with this event
 * @property {string} [design_studio_mode] - The Design Studio mode the user is currently in
 * @property {string} [destination_url] - The destination url for the link pressed
 * @property {string} [device_type] - Type of device being viewed
 * @property {string} [email] - Email address of a user
 * @property {string} [feature] - Name of associated feature
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [job_id] - The Hyperion job id
 * @property {string} [last_name] - Last name of a user
 * @property {string} [link_location] - The location of the link on the page or screen.
 * @property {string} link_text - The text on the link.
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the link was pressed.
 * @property {number} [partner_id] - The Partner if link is embedded with in a Partner specific page context
 * @property {string} [partner_name] - Partner Name of a user
 * @property {string} [platform_type] - mobile or web
 * @property {boolean} primary_cta - Whether the link is the primary call to action on the page or screen.
 * @property {number} [project_id] - ID of the Gen AI project
 * @property {string} [provider_name] - The manufacturer of the product/material
 * @property {string} [search_query] - The input that is being searched as part of Google search link
 * @property {string} [session_id] - ID to track events triggered during a single session
 * @property {string} [track_id] - Static id for tracking link
 * @property {boolean} [user_authenticated] - Indicates if the event was triggered for an anonymous user or a logged in user.
 * @property {string} [user_email] - User's email
 * @property {number} [user_id] - Hyperion user ID
 */
/**
 * @typedef LinkPressed
 * @property {number} [ai_display_image_id] - Id of display image in Homeowner App
 * @property {number} [ai_generated_image_id] - Id of generated image in Homeowner App
 * @property {number} [ai_original_image_id] - Id of original image in Homeowner App
 * @property {string} [backend_id_type] - Database object name associated with this event
 * @property {string} [backend_id_value] - Database object id associated with this event
 * @property {string} [design_studio_mode] - The Design Studio mode the user is currently in
 * @property {string} [destination_url] - The destination url for the link pressed
 * @property {string} [device_type] - Type of device being viewed
 * @property {string} [email] - Email address of a user
 * @property {string} [feature] - Name of associated feature
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [job_id] - The Hyperion job id
 * @property {string} [last_name] - Last name of a user
 * @property {string} [link_location] - The location of the link on the page or screen.
 * @property {string} link_text - The text on the link.
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the link was pressed.
 * @property {number} [partner_id] - The Partner if link is embedded with in a Partner specific page context
 * @property {string} [partner_name] - Partner Name of a user
 * @property {string} [platform_type] - mobile or web
 * @property {boolean} primary_cta - Whether the link is the primary call to action on the page or screen.
 * @property {number} [project_id] - ID of the Gen AI project
 * @property {string} [provider_name] - The manufacturer of the product/material
 * @property {string} [search_query] - The input that is being searched as part of Google search link
 * @property {string} [session_id] - ID to track events triggered during a single session
 * @property {string} [track_id] - Static id for tracking link
 * @property {boolean} [user_authenticated] - Indicates if the event was triggered for an anonymous user or a logged in user.
 * @property {string} [user_email] - User's email
 * @property {number} [user_id] - Hyperion user ID
 */
/**
 * @typedef LoginSsoStarted
 * @property {string} button_or_link - Whether the element pressed was a button or a link.
 * @property {string} [button_or_link_location] - The location of the button or link on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef LoginStarted
 * @property {string} button_or_link - Whether the element pressed was a button or a link.
 * @property {string} [button_or_link_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef ModalViewed
 * @property {boolean} [dense_guidance_capture] - A boolean indicating whether the user is using dense for the current capture
 * @property {boolean} [dense_guidance_enabled_for_camera] - A boolean indicating whether dense is enabled for the camera.
 * @property {string} [dense_guidance_mode] - A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
 * @property {string} [feature] - Name of associated feature
 * @property {string} [job_client_identifier] - The client identifier of the Job the user is capturing.
 * @property {string} [job_deliverable] - the name of a job deliverable, such as "capture only", "complete", etc
 * @property {string} [name] - The name of the modal.
 * @property {string} [output_id] - A unique id to identify the artifact being viewed in the modal
 * @property {string} [page_or_screen_name] - The page or screen name where the modal was viewed
 * @property {string} [track_id] - Supplementary tracking identifier for the specific instance where the modal was viewed
 */
/**
 * @typedef ModelComponentSelected
 * @property {string} [backend_id_type] - Database object name associated with this event
 * @property {string} [backend_id_value] - Database object value associated with this event
 * @property {number} [job_id] - The Hyperion Job Id
 * @property {string} [page_or_screen_name] - Where does this model component appear
 * @property {boolean} [primary_cta] - Is this field the primary cta
 * @property {number} [user_id] - Id of the user
 */
/**
 * @typedef ModelInteracted
 * @property {string} [design_studio_mode] - The Design Studio mode the user is currently in
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [fullscreen_iframe] - If Design Studio is embedded in an iframe, this value will show if the model interacted event happened while the iframe is in fullscreen mode
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [iframe_location] - If Design Studio is embedded in an iframe, this is the "location" of the iframe (e.g. hover_property-details-page, james-hardie_homepage, unknown, etc...). This property needs to be manually set as a URL param in the iframe src url.
 * @property {string} interaction_type - The type of interaction the user made. Possible values are "rotate", "pan", or "zoom".
 * @property {number} [job_id] - The Hyperion Job Id.
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 */
/**
 * @typedef ModuleViewed
 * @property {number} [ai_display_image_id] - ID of the relevant AIDisplayImage
 * @property {number} [ai_generated_image_id] - ID of the relevant AIGeneratedImage
 * @property {boolean} [ai_image_watermarked] - Whether an image was watermarked
 * @property {number} [ai_original_image_id] - ID of the relevant AIDisplayImage
 * @property {string} [color_group] - The color group from a color selected that was not defined in texture details, "Popular", "Statement", "Reds", etc...
 * @property {string} [color_hex] - The hexadecimal representation of the color selected. For example, "#ffffff", "#ebdec4", "#ddb582", etc...
 * @property {string} [color_name] - The name of the color selected. For example generic names "Reds" and "Greens", or branded names "Rustic Barn", "Wintery White", etc...
 * @property {string} [device_type] - Type of device being viewed
 * @property {string} [edit_region] - The region being edited
 * @property {string} [edit_type] - The type of edit (paint, walls, roof, etc)
 * @property {string} [feature] - The name of the associated feature
 * @property {number} [job_id] - The Hyperion Job ID
 * @property {string} [manufacturer] - Manufacturer of product
 * @property {number} [org_id] - User's org ID
 * @property {string} [page_or_screen_name] - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - The Partner if button is embedded with in a Partner specific page context
 * @property {number} [project_id] - ID of the relevant Project
 * @property {string} [session_id] - ID to track events triggered by anonymous users
 * @property {string} [space_type] - Space type of uploaded image in Homeowner App
 * @property {string} [style] - Style of image or design
 * @property {string} [track_id] - Static track id for module viewed
 * @property {boolean} [user_authenticated] - Used to track if an event is triggered by an anonymous users
 * @property {number} [user_id] - The Hyperion Job ID
 */
/**
 * @typedef OptionSelected
 * @property {string} [backend_id_type] - Database object name associated with this event
 * @property {string} [backend_id_value] - Database object value associated with this event
 * @property {string} [email] - Email address of a user
 * @property {string} [feature] - Name of associated feature

 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [job_id] - The Hyperion Job Id
 * @property {string} [last_name] - Last name of a user
 * @property {string} [option_type] - The type of frontend selector (radio, dropdown)
 * @property {string} options - The description of the set of options
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} [page_or_screen_name] - Where does this select appear
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} [primary_cta] - Is this field the primary CTA
 * @property {string} selection - The thing being selected
 * @property {string} [track_id] - Supplementary tracking identifier for the specific instance of an option being selected
 * @property {string} [user_email] - 
 * @property {number} [user_id] - Id of the user
 */
/**
 * @typedef PageViewed
 * @property {boolean} [account_type_combined] - Whether account type is unified/combined or not.
See: #4961
 * @property {string} [design_studio_mode] - The Design Studio mode the user is currently in
 * @property {string} [duration_loading] - 
 * @property {string} [failure_reason] - For error screens, the reason the user is seeing this particular error
 * @property {string} [feature] - Name of associated feature
 * @property {boolean} [include_self_qual] - Whether personal information page (combined) is displayed or not for the onboarding phase v1.
* See OnboardingTests type for more details.
 * @property {string} [job_deliverable] - name deliverable type (complete, roof_only, etc)
 * @property {number} [job_id] - The Hyperion Job Id.
 * @property {string} [job_name] - the name of the property/project/job
 * @property {string} [job_state] - the state of the job (FAILED, COMPLETE, PENDING, etc)
 * @property {string} [onboarding_test] - Combined value refers to the unified page to fill out name, company name and phone number (see UserPersonalInformation component).
* Separated value refers to the separated pages to fill out the same information.
 * @property {number} [org_id] - 
 * @property {string} [org_name] - 
 * @property {string} [page_or_screen_name] - The name of the page.
 * @property {number} [partner_id] - Partner specific page
 * @property {string} [platform_type] - mobile or web
 * @property {number} [pro_page_org_id] - ID of the org owning the pro page.
 * @property {number} [production_list_id] - ID of a production list from the ehi code base
 * @property {string} [referrer] - The Document.referrer property from the URI of the web page 
 * @property {string} [session_id] - ID to track events triggered during a single session
 * @property {string} [track_id] - Key for the tracked event
 * @property {string} [user_email] - 
 * @property {number} [user_id] - 
 */
/**
 * @typedef PinchedZoom
 * @property {string} [ai_displayed_image_id] -
 * @property {number} [ai_generated_image_id] -
 * @property {boolean} [ai_image_watermarked] - Whether an image was watermarked
 * @property {number} [ai_original_image_id] -
 * @property {string} [color_group] - Selected color group
 * @property {string} [color_hex] - Selected color value
 * @property {string} [device_type] -
 * @property {string} [feature] - Associated feature
 * @property {string} [manufacturer] - Manufacture's name of applied product
 * @property {number} [org_id] -
 * @property {string} [page_or_screen_name] -
 * @property {number} [partner_id] -
 * @property {string} [session_id] -
 * @property {string} [space_type] -
 * @property {string} [style] - Style used to generate image
 * @property {string} track_id -
 * @property {boolean} [user_authenticated] -
 * @property {number} [user_id] -
 */
/**
 * @typedef ProductSelected
 * @property {number} [ai_display_image_id] - Id of display image in Homeowner App
 * @property {number} [ai_generated_image_id] - Id of generated image in Homeowner App
 * @property {number} [ai_original_image_id] - Id of original image uploaded by user in Homeowner App
 * @property {string | null} [category] - The category of product selected. For example, "Walls", "Roof", "Trim", etc...
 * @property {string | null} [color_group] - The color group from a color selected that was not defined in texture details, "Popular", "Statement", "Reds", etc...
 * @property {string | null} [color_hex] - The hexadecimal representation of the color selected. For example, "#ffffff", "#ebdec4", "#ddb582", etc...
 * @property {string | null} [color_name] - The name of the color selected. For example generic names "Reds" and "Greens", or branded names "Rustic Barn", "Wintery White", etc...
 * @property {string} [design_studio_mode] - The Design Studio mode the user is currently in
 * @property {string} [device_type] - Type of device being viewed
 * @property {string} [edit_region] - The region being edited
 * @property {string} [edit_type] - The type of edit (paint, walls, roof, etc)
 * @property {string} [email] - Email address of a user
 * @property {string} [feature] - Name of associated feature
 * @property {string} [first_name] - First name of a user
 * @property {string | null} [frame] - The parametric frame type for a window selected (will only be present if the product selected is a window). For example "casement" or "slider"...
 * @property {string | null} [grid] - The parametric grid type for a window selected (will only be present if the product selected is a window). For example "diamond" or "farmhouse"...
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [job_id] - The Hyperion Job Id.
 * @property {string} [last_name] - Last name of a user
 * @property {string} [manufacturer] - Manufacturer of product
 * @property {number} [material_classes_edited] - The number of material classes edited by the selection
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the product was selected.
 * @property {string | null} parameter - The parameter of the product the user selected. For example, “Roofing Types”, “Style”, etc..
 * @property {number} [partner_id] - The Partner if button is embedded with in a Partner specific page context
 * @property {string} [partner_name] - Partner Name of a user
 * @property {string | null} product - The kind of product the user selected. For example, "Walls", "Roof", "Trim", etc..
 * @property {string} [product_group] - Grouping of the product selected
 * @property {string} [product_name] - Name of the product selected
 * @property {string | null} [product_type] - The type of texture. For example "horizontal", "stone", "asphalt", "brick", etc...
 * @property {any | null} selection - The option the user selected. For example, “Metal”, “Standing Seam”, etc..
 * @property {string | null} [selection_type] - What type of selection (first generation or re-generate)
 * @property {string} [session_id] - ID to track events triggered during a single session
 * @property {string} [space_type] - Space type of uploaded image in Homeowner App
 * @property {string} [style] - Style of image or design
 * @property {string | null} [texture_color_group] - The color group assigned with the other texture properties. For example "Beiges", "Reds", etc...
 * @property {number | null} [texture_id] - The id of the texture selected.
 * @property {string | null} [texture_name] - The name of texture color, typically a duplicate of texture_color_group
 * @property {string | null} [texture_shape] - The shape of the texture. For example "Straight Shake", "Staggered Shake", "Scalloped", etc...
 * @property {string | null} [texture_size] - The size of the selected texture. For example `3"`, `4"`, `4.5"`, etc...
 * @property {string | null} [texture_style] - The style of the selected texture. For example "Dutch Lap", "Board and Batten", etc...
 * @property {string | null} [texture_type] - The type of texture. For example "Cedarmill" or "Smooth"
 * @property {string} [track_id] - Static track id for product selected
 * @property {boolean} [user_authenticated] - Indicates if the event was triggered for an anonymous user or a logged in user.
 * @property {number} [user_id] - user's id
 */
/**
 * @typedef ProfessionalIdentified
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string | null} [button_or_link_text] - The text on the button or link, likely replaced button_text.
 * @property {string} [button_text] - The text on the button.
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef PropertyPressed
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} [email] - Email address of a user
 * @property {boolean} [example_job] - Whether the property is an example job.
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef RequestFormOpened
 * @property {string} [feature] - Name of associated feature
 * @property {number} [job_id] - The ID of the job for which the rendering is for
 * @property {number} [org_id] - The Org of the requesting user
 * @property {string} [rendering_id] -
 * @property {string} [track_id] - Static track id for button
 */
/**
 * @typedef SavedImage
 * @property {number} [ai_generated_image_id] - ID of the relevant AIGeneratedImage
 * @property {number} [ai_original_image_id] - ID of the relevant AiOriginalImage
 * @property {string} [device_type] - Type of device being viewed
 * @property {string} [feature] - Name of associated feature
 * @property {string | null} [image_type] - Type of image being saved (i.e. edited or generated)
 * @property {number} [org_id] - Org Id of user
 * @property {string} [page_or_screen_name] - The name of the page or screen when the event was triggered.
 * @property {number} [partner_id] - Partner Id associated with the user
 * @property {number} [project_id] - Project Id that image is being saved to
 * @property {string | null} [save_to] - Where the image is being saved (e.g. Project or Saved ideas)
 * @property {string} [session_id] - ID to track events triggered during a single session
 * @property {string} [track_id] - Static track id for event
 * @property {boolean} [user_authenticated] - Indicates if the event was triggered for an anonymous user or a logged in user.
 * @property {number} [user_id] - User's Hyperion Id
 */
/**
 * @typedef ScreenViewed
 * @property {boolean} [dense_guidance_capture] - A boolean indicating whether the user is using dense for the current capture
 * @property {boolean} [dense_guidance_enabled_for_camera] - A boolean indicating whether dense is enabled for the camera.
 * @property {string} [dense_guidance_mode] - A string with 3 possible values “disable”, “lite”, “full”. Different dense modes determines what dense features are enabled.
 * @property {string} [job_client_identifier] - The client identifier of the Job the user is capturing.
 */
/**
 * @typedef SessionStarted
 * @property {string} [email] - Email address of a user
 * @property {string} [embedded_at] - The url of the parent window that the application is embedded at.
 * @property {string} [feature] - Name of associated feature
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [job_id] - The Hyperion Job Id
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {string} session_id - ID to track events triggered during a single session
 * @property {string} [split_key] - The Split key identifying the user
 * @property {number} [user_id] - Id of the user
 */
/**
 * @typedef SettingChanged
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {string} setting_text - The name of the setting.
 * @property {any | null} value - The value the setting was changed to.
 */
/**
 * @typedef SignupStarted
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_or_link - Whether the element pressed was a button or a link.
 * @property {string} button_text - The text on the button.
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef SupportContacted
 * @property {string} button_or_link - Whether the element pressed was a button or a link.
 * @property {string} [button_or_link_location] - The location of the button or link on the page or screen.
 * @property {string} button_or_link_text - The text on the button or link.
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef Swipe
 * @property {number} [ai_generated_image_id] - ID of the relevant AiGeneratedImage
 * @property {number} [ai_original_image_id] - ID of the relevant AiOriginalImage
 * @property {string} [direction] - Direction of the swipe
 * @property {string} [email] - Email address of a user
 * @property {string} [feature] - Name of associated feature
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {number} [job_id] - The Hyperion job id
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - The Hyperion org id
 * @property {string} [org_name] - Org Name of a user
 * @property {string} page_or_screen_name - The name of the page or screen where the user swiped
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {string} [session_id] - Session id used to track events for anonymous users
 * @property {string} [style] - Style of image being swiped through
 * @property {string} [track_id] - Static track id for swipe
 * @property {boolean} [user_authenticated] - Indicates if the event was triggered from an anonymous user or not
 * @property {number} [user_id] - The Hyperion user id
 */
/**
 * @typedef TabViewed
 * @property {string} [button_location] -
 * @property {string} [design_studio_mode] - The Design Studio mode the user is currently in
 * @property {string} [feature] - Name of associated feature
 * @property {number} [job_id] - The Hyperion Job Id.
 * @property {string} [page_or_screen_name] - The name of the page.
 * @property {number} [partner_id] - Partner specific page
 */
/**
 * @typedef TextInput
 * @property {string} [backend_id_type] - Database object name associated with this event
 * @property {string} [backend_id_value] - Database object value associated with this event
 * @property {string} [email] - Email address of a user
 * @property {string} [first_name] - First name of a user
 * @property {boolean} [homeowner] - Whether the user is a Homeowner
 * @property {string} [input_label] - The label of the text input.
 * @property {string} [input_location] - The location of the input on the page or screen.
 * @property {string} input_value - The value of the text input.
 * @property {number} [job_id] - The Hyperion Job Id
 * @property {string} [last_name] - Last name of a user
 * @property {number} [org_id] - Org Id of a user
 * @property {string} [org_name] - Org Name of a user
 * @property {string} [page_or_screen_name] - Where does this text input appear
 * @property {number} [partner_id] - Partner Id of a user
 * @property {string} [partner_name] - Partner Name of a user
 * @property {string} [platform_type] - mobile or web
 * @property {number} [template_id] - template id from ehi code base
 * @property {string} [template_name] - template name from ehi code base
 * @property {string} [trade_type] - trade type from ehi code base
 * @property {string} [user_email] -
 * @property {number} [user_id] -
 */

/**
 * The user created an account.
 *
 * @param {AccountCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountCreated(
	props: AccountCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Account Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user agreed to the terms of service and privacy policy.
 *
 * @param {AgreedToTosPrivacy} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function agreedToTosPrivacy(
	props: AgreedToTosPrivacy,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Agreed to TOS_Privacy',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed the back button.
 *
 * @param {BackButtonPressed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function backButtonPressed(
	props: BackButtonPressed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Back Button Pressed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed a button. This is the generic event used for all button presses, other than the ones that have their own dedicated event name.
 *
 * @param {ButtonImpression} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function buttonImpression(
	props: ButtonImpression,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Button Impression',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed a button. This is the generic event used for all button presses, other than the ones that have their own dedicated event name.
 *
 * @param {ButtonPressed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function buttonPressed(
	props: ButtonPressed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Button Pressed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user started a capture.
 *
 * @param {CaptureStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function captureStarted(
	props: CaptureStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Capture Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user submitted a capture.
 *
 * @param {CaptureSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function captureSubmitted(
	props: CaptureSubmitted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Capture Submitted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user selected a checkbox.
 *
 * @param {CheckboxSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkboxSelected(
	props: CheckboxSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Checkbox Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user toggled a checkbox. This is the generic event used for all checkbox toggles, other than the ones that have their own dedicated event name.
 *
 * @param {CheckboxToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkboxToggled(
	props: CheckboxToggled,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Checkbox Toggled',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Data was saved in a programmatic manner, without being directly triggered by a user interaction.
 *
 * @param {DataSaved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function dataSaved(
	props?: DataSaved,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('Data Saved', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * The user started a Dense capture.
 *
 * @param {DenseCaptureStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function denseCaptureStarted(
	props: DenseCaptureStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Dense Capture Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user dragged an element
 *
 * @param {ElementDragged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function elementDragged(
	props: ElementDragged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Element Dragged',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user viewed an element/component on a page/screen.
 *
 * @param {ElementViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function elementViewed(
	props?: ElementViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Element Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user encountered an error
 *
 * @param {Error} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function error(
	props: Error,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('Error', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * The user upvoted a potential new feature in Design Studio.
 *
 * @param {FeatureUpvoted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function featureUpvoted(
	props: FeatureUpvoted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Feature Upvoted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user selected the Homeowner option.
 *
 * @param {HomeownerIdentified} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function homeownerIdentified(
	props: HomeownerIdentified,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Homeowner Identified',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed on a image displayed
 *
 * @param {ImageClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function imageClicked(
	props?: ImageClicked,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Image Clicked',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Event mainly used for tracking AI Designer image generation latency
 *
 * @param {ImageLoaded} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function imageLoaded(
	props?: ImageLoaded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Image Loaded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * Event used for tracking the upload time of AI Original Images. Tracking happens in 3 parts which are all tracked using this event.
 *
 * @param {ImageUploaded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function imageUploaded(
	props: ImageUploaded,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Image Uploaded',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed the input
 *
 * @param {InputPressed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function inputPressed(
	props?: InputPressed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Input Pressed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user selected the Homeowner option.
 *
 * @param {InsuranceIdentified} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function insuranceIdentified(
	props: InsuranceIdentified,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Insurance Identified',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed a link. This is the generic event used for all link presses, other than the ones that have their own dedicated event name.
 *
 * @param {LinkImpression} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function linkImpression(
	props: LinkImpression,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Link Impression',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed a link. This is the generic event used for all link presses, other than the ones that have their own dedicated event name.
 *
 * @param {LinkPressed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function linkPressed(
	props: LinkPressed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Link Pressed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user started SSO login.
 *
 * @param {LoginSsoStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function loginSsoStarted(
	props: LoginSsoStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Login SSO Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user started login.
 *
 * @param {LoginStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function loginStarted(
	props: LoginStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Login Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user viewed a message
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function messageViewed(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Message Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user viewed a modal.
 *
 * @param {ModalViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function modalViewed(
	props?: ModalViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Modal Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user clicked on a facet of the 3d model.
 *
 * @param {ModelComponentSelected} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function modelComponentSelected(
	props?: ModelComponentSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Model Component Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user rotated, panned, or zoomed the 3D model in Design Studio.
 *
 * @param {ModelInteracted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function modelInteracted(
	props: ModelInteracted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Model Interacted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user has viewed the feature module
 *
 * @param {ModuleViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function moduleViewed(
	props?: ModuleViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Module Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * User selected something from a multiple-choice select element, like a dropdown.
 *
 * @param {OptionSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function optionSelected(
	props: OptionSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Option Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user viewed a page. Page calls are automatically converted to this event.
 *
 * @param {PageViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pageViewed(
	props?: PageViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Page Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user has initiated a pinch to zoom action on screen
 *
 * @param {PinchedZoom} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pinchedZoom(
	props: PinchedZoom,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Pinched Zoom',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user made a product selection in Design Studio.
 *
 * @param {ProductSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productSelected(
	props: ProductSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Product Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user selected the Professional option.
 *
 * @param {ProfessionalIdentified} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function professionalIdentified(
	props: ProfessionalIdentified,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Professional Identified',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed a property on the Property List screen.
 *
 * @param {PropertyPressed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function propertyPressed(
	props: PropertyPressed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Property Pressed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user opened the intake form for Renderings
 *
 * @param {RequestFormOpened} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function requestFormOpened(
	props?: RequestFormOpened,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Request Form Opened',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user saved an image for GenAI
 *
 * @param {SavedImage} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function savedImage(
	props?: SavedImage,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Saved Image',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user viewed a screen. Screen calls are automatically converted to this event.
 *
 * @param {ScreenViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function screenViewed(
	props?: ScreenViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Screen Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user triggered a new session
 *
 * @param {SessionStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sessionStarted(
	props: SessionStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Session Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user changed a setting.
 *
 * @param {SettingChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingChanged(
	props: SettingChanged,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Setting Changed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user started signup.
 *
 * @param {SignupStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signupStarted(
	props: SignupStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Signup Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user contacted Support.
 *
 * @param {SupportContacted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function supportContacted(
	props: SupportContacted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Support Contacted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user swiped left or right on a screen.
 *
 * @param {Swipe} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function swipe(
	props: Swipe,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('Swipe', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * The user viewed a page. Page calls are automatically converted to this event.
 *
 * @param {TabViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function tabViewed(
	props?: TabViewed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('Tab Viewed', props || {}, withTypewriterContext(options), callback)
	}
}
/**
 * The user updates a text input
 *
 * @param {TextInput} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function textInput(
	props: TextInput,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track('Text Input', props || {}, withTypewriterContext(options), callback)
	}
}

const clientAPI = {
	/**
	 * Updates the run-time configuration of this Typewriter client.
	 *
	 * @param {TypewriterOptions} options - the options to upsert
	 *
	 * @typedef {Object} TypewriterOptions
	 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
	 * 		calls are forwarded on to. Defaults to window.analytics.
	 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
	 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
	 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
	 * 		will be logged to stderr.
	 */
	setTypewriterOptions,
	/**
	 * The user created an account.
	 *
	 * @param {AccountCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	accountCreated,
	/**
	 * The user agreed to the terms of service and privacy policy.
	 *
	 * @param {AgreedToTosPrivacy} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	agreedToTosPrivacy,
	/**
	 * The user pressed the back button.
	 *
	 * @param {BackButtonPressed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	backButtonPressed,
	/**
	 * The user pressed a button. This is the generic event used for all button presses, other than the ones that have their own dedicated event name.
	 *
	 * @param {ButtonImpression} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	buttonImpression,
	/**
	 * The user pressed a button. This is the generic event used for all button presses, other than the ones that have their own dedicated event name.
	 *
	 * @param {ButtonPressed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	buttonPressed,
	/**
	 * The user started a capture.
	 *
	 * @param {CaptureStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	captureStarted,
	/**
	 * The user submitted a capture.
	 *
	 * @param {CaptureSubmitted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	captureSubmitted,
	/**
	 * The user selected a checkbox.
	 *
	 * @param {CheckboxSelected} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	checkboxSelected,
	/**
	 * The user toggled a checkbox. This is the generic event used for all checkbox toggles, other than the ones that have their own dedicated event name.
	 *
	 * @param {CheckboxToggled} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	checkboxToggled,
	/**
	 * Data was saved in a programmatic manner, without being directly triggered by a user interaction.
	 *
	 * @param {DataSaved} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	dataSaved,
	/**
	 * The user started a Dense capture.
	 *
	 * @param {DenseCaptureStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	denseCaptureStarted,
	/**
	 * The user dragged an element
	 *
	 * @param {ElementDragged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	elementDragged,
	/**
	 * The user viewed an element/component on a page/screen.
	 *
	 * @param {ElementViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	elementViewed,
	/**
	 * The user encountered an error
	 *
	 * @param {Error} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	error,
	/**
	 * The user upvoted a potential new feature in Design Studio.
	 *
	 * @param {FeatureUpvoted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	featureUpvoted,
	/**
	 * The user selected the Homeowner option.
	 *
	 * @param {HomeownerIdentified} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	homeownerIdentified,
	/**
	 * The user pressed on a image displayed
	 *
	 * @param {ImageClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	imageClicked,
	/**
	 * Event mainly used for tracking AI Designer image generation latency
	 *
	 * @param {ImageLoaded} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	imageLoaded,
	/**
	 * Event used for tracking the upload time of AI Original Images. Tracking happens in 3 parts which are all tracked using this event.
	 *
	 * @param {ImageUploaded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	imageUploaded,
	/**
	 * The user pressed the input
	 *
	 * @param {InputPressed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	inputPressed,
	/**
	 * The user selected the Homeowner option.
	 *
	 * @param {InsuranceIdentified} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	insuranceIdentified,
	/**
	 * The user pressed a link. This is the generic event used for all link presses, other than the ones that have their own dedicated event name.
	 *
	 * @param {LinkImpression} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	linkImpression,
	/**
	 * The user pressed a link. This is the generic event used for all link presses, other than the ones that have their own dedicated event name.
	 *
	 * @param {LinkPressed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	linkPressed,
	/**
	 * The user started SSO login.
	 *
	 * @param {LoginSsoStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	loginSsoStarted,
	/**
	 * The user started login.
	 *
	 * @param {LoginStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	loginStarted,
	/**
	 * The user viewed a message
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	messageViewed,
	/**
	 * The user viewed a modal.
	 *
	 * @param {ModalViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	modalViewed,
	/**
	 * The user clicked on a facet of the 3d model.
	 *
	 * @param {ModelComponentSelected} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	modelComponentSelected,
	/**
	 * The user rotated, panned, or zoomed the 3D model in Design Studio.
	 *
	 * @param {ModelInteracted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	modelInteracted,
	/**
	 * The user has viewed the feature module
	 *
	 * @param {ModuleViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	moduleViewed,
	/**
	 * User selected something from a multiple-choice select element, like a dropdown.
	 *
	 * @param {OptionSelected} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	optionSelected,
	/**
	 * The user viewed a page. Page calls are automatically converted to this event.
	 *
	 * @param {PageViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	pageViewed,
	/**
	 * The user has initiated a pinch to zoom action on screen
	 *
	 * @param {PinchedZoom} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	pinchedZoom,
	/**
	 * The user made a product selection in Design Studio.
	 *
	 * @param {ProductSelected} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	productSelected,
	/**
	 * The user selected the Professional option.
	 *
	 * @param {ProfessionalIdentified} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	professionalIdentified,
	/**
	 * The user pressed a property on the Property List screen.
	 *
	 * @param {PropertyPressed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	propertyPressed,
	/**
	 * The user opened the intake form for Renderings
	 *
	 * @param {RequestFormOpened} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	requestFormOpened,
	/**
	 * The user saved an image for GenAI
	 *
	 * @param {SavedImage} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	savedImage,
	/**
	 * The user viewed a screen. Screen calls are automatically converted to this event.
	 *
	 * @param {ScreenViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	screenViewed,
	/**
	 * The user triggered a new session
	 *
	 * @param {SessionStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	sessionStarted,
	/**
	 * The user changed a setting.
	 *
	 * @param {SettingChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	settingChanged,
	/**
	 * The user started signup.
	 *
	 * @param {SignupStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	signupStarted,
	/**
	 * The user contacted Support.
	 *
	 * @param {SupportContacted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	supportContacted,
	/**
	 * The user swiped left or right on a screen.
	 *
	 * @param {Swipe} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	swipe,
	/**
	 * The user viewed a page. Page calls are automatically converted to this event.
	 *
	 * @param {TabViewed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	tabViewed,
	/**
	 * The user updates a text input
	 *
	 * @param {TextInput} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	textInput,
}

export default new Proxy<typeof clientAPI>(clientAPI, {
	get(target, method) {
		if (typeof method === 'string' && target.hasOwnProperty(method)) {
			return target[method as keyof typeof clientAPI]
		}

		return () => {
			console.warn(`⚠️  You made an analytics call (${String(
				method
			)}) that can't be found. Either:
    a) Re-generate your typewriter client: \`npx typewriter\`
    b) Add it to your Tracking Plan: https://app.segment.com/hover3d/protocols/tracking-plans/rs_2ckclXTSlf1ajQ6E42BmJwKHn3V`)
			const a = analytics()
			if (a) {
				a.track(
					'Unknown Analytics Call Fired',
					{
						method,
					},
					withTypewriterContext()
				)
			}
		}
	},
})
